import { useEffect, useRef } from 'react';
import { Config, Connect, ConnectEvents } from '@vkontakte/superappkit';
import { useDispatch } from 'react-redux';
import { userActions } from '../../../actions';

export function VkLoginButton() {
    const elementRef = useRef(null);
    const dispatch = useDispatch();
    useEffect(() => {
        Config.init({
            appId: 51750213, // Идентификатор приложения
        });

        const oneTapButton = Connect.buttonOneTapAuth({
            // Обязательный параметр в который нужно добавить обработчик событий приходящих из SDK
            callback: function (e) {
                const type = e.type;
                console.log('VK login click', e);

                if (!type) {
                    return false;
                }

                switch (type) {
                    case ConnectEvents.OneTapAuthEventsSDK.LOGIN_SUCCESS: // = 'VKSDKOneTapAuthLoginSuccess'
                        dispatch(
                            userActions.loginByVk({
                                userId: e.payload.user.id,
                                token: e.payload.token,
                                uuid: e.payload.uuid,
                            })
                        );
                        return false;
                    // Все, что ниже, нужно для сценариев, требующих редиректа на VK, для авторизации в ВК.
                    // Для этих событий нужно открыть полноценный VK ID чтобы
                    // пользователь дорегистрировался или подтвердил телефон
                    case ConnectEvents.OneTapAuthEventsSDK.FULL_AUTH_NEEDED: //  = 'VKSDKOneTapAuthFullAuthNeeded'
                    case ConnectEvents.OneTapAuthEventsSDK.PHONE_VALIDATION_NEEDED: // = 'VKSDKOneTapAuthPhoneValidationNeeded'
                    case ConnectEvents.ButtonOneTapAuthEventsSDK.SHOW_LOGIN: // = 'VKSDKButtonOneTapAuthShowLogin'
                        return Connect.redirectAuth({ url: window.location.href });
                    // url - строка с url, на который будет произведён редирект после авторизации.
                    // state - состояние вашего приложение или любая произвольная строка, которая будет добавлена к url после авторизации.
                    // Пользователь перешел по кнопке "Войти другим способом" (прим. - у нас этого вроде как нет)
                    case ConnectEvents.ButtonOneTapAuthEventsSDK.SHOW_LOGIN_OPTIONS: // = 'VKSDKButtonOneTapAuthShowLoginOptions'
                        // Параметр screen: phone позволяет сразу открыть окно ввода телефона в VK ID
                        // Параметр url: ссылка для перехода после авторизации. Должен иметь https схему. Обязательный параметр.
                        return Connect.redirectAuth({ screen: 'phone', url: window.location.href });
                    default:
                        return false;
                }
            },
            // Не обязательный параметр с настройками отображения OneTap
            options: {
                showAlternativeLogin: false, // Отображение кнопки "Войти другим способом"
                showAgreements: false,
                buttonSkin: 'flat',
                displayMode: 'default', // Режим отображения кнопки 'default' | 'name_phone' | 'phone_name'
                buttonStyles: {
                    borderRadius: 6, // Радиус скругления кнопок
                    height: 40,
                },
            },
        });

        elementRef.current.appendChild(oneTapButton.getFrame());
        return () => {
            oneTapButton.destroy();
        };
    }, [elementRef, dispatch]);

    return <div ref={elementRef} />;
}
